import { componerRutaApi } from "funciones/util";

export const getPueblos = () => componerRutaApi("/pueblos");

export const getPuebloByCod = (codPueblo) =>
  componerRutaApi("/pueblo/" + codPueblo);

export const getLocalByCod = (codLocal) => componerRutaApi("/menu/" + codLocal);

export const getTablonByCodPueblo = (codPueblo) =>
  componerRutaApi("/tablon/" + codPueblo);
